import { Basket } from './Basket';

export class TransferBasket {
    basket: Basket;
    itemsnottransferred: Array<string>;

    public static Make(obj: any): TransferBasket {
        const transferBasket = new TransferBasket();
        Object.assign(transferBasket, obj);
        return transferBasket;
    }
}
